import AjaxService from "../../platform/ajax/AjaxService";
import {OptiselEventJson} from "../optiselevent/OptiselEventHistoryPage";
import {useFetchAllObjs, useFetchAllObjsWithRefetchCapability} from "../../platform/hooks/PlatformTypeScriptHooks";
import {AssignableUserApiJson} from "./AssignableUserApiJson";


export const callApiAttachOptiselEventToIssue = (optiselEventId: string, issueId: string) => {
    AjaxService.postJson(`/api/issue/${issueId}/attach-event?eventId=${optiselEventId}`, {}).then(result => {

        console.log("Received  response", result);

    }).finally(() => {

    });
}

export const callApiDetachOptiselEventToIssue = (optiselEventId: string, issueId: string) => {
    return AjaxService.postJson(`/api/issue/${issueId}/detach-event?eventId=${optiselEventId}`, {}).then(result => {

        console.log("Received  response", result);

    }).finally(() => {

    });
}


export const callApiDeleteIssue = (issueId: string) => {
    return AjaxService.delete(`/api/issue/${issueId}`);
}

export const callApiAssignUserToIssue = (issueId: string, userId: string) => {
    return AjaxService.postJson(`/api/issue/${issueId}/assign-user?userId=${encodeURIComponent(userId)}`, {});
}

export const callApiArchiveIssue = (issueId: string, reason: string) => {
    return AjaxService.postJson(`/api/issue/${issueId}/archive`, {reason: reason});
}

export const callApiRestoreIssueFromArchive = (issueId: string) => {
    return AjaxService.postJson(`/api/issue/${issueId}/restore-from-archive`, {});
}

export const callApiCloseIssueAsInquiry = (issueId: string, inquiryNumber: string) => {
    return AjaxService.postJson(`/api/issue/${issueId}/close-as-inquiry`, {number: inquiryNumber});
}

export const callApiCloseIssueAsOrder = (issueId: string, wentechCaseNumber: string) => {
    return AjaxService.postJson(`/api/issue/${issueId}/close-as-order`, {number: wentechCaseNumber});
}

export const useAllIssueAttachedOptiselEvents = (issueId: string): { result: OptiselEventJson[] | "loading"; refetch: () => void } => {
    const {refetch, result} = useFetchAllObjsWithRefetchCapability<OptiselEventJson[]>(`/api/issue/${issueId}/attached-events`);
    return {
        result: result ?? "loading",
        refetch
    }
}

export const useAssignableUsers = (): { result: AssignableUserApiJson[] | "loading"; refetch: () => void } => {
    const {refetch, result} = useFetchAllObjsWithRefetchCapability<AssignableUserApiJson[]>("/api/issue/assignable-users");
    return {
        result: result ?? "loading",
        refetch
    }
}